import { Container, Card, Row, Col } from 'react-bootstrap'
import { CardRowItem } from '../../cardRowItem'
import { Separator } from 'components/styledComponents/Separator'
import {
  IProposalProposalSummarySectionProps,
  IProposalProposalSummarySectionCommissionsProps,
} from './proposalTypes'
import ProposalSummarySectionCommissions from './proposalSummarySectionCommissions'
import { ITheme } from 'utils/type'

interface IInputProps {
  data: IProposalProposalSummarySectionProps
  commissionProps: IProposalProposalSummarySectionCommissionsProps
  inEstimateDetail?: boolean
  pdf?: boolean
  title: string
  theme: ITheme
}

const proposalSummarySection = (props: IInputProps) => {
  return (
    <div className="card-section proposal-summary-section print-page-break-before">
      <Container
        className={
          props.inEstimateDetail && !props.pdf ? 'p-0' : 'section mt-4'
        }
      >
        <Card
          className={
            props.pdf ? 'mb-13rem pdf-card-container' : 'mb-13rem card-shadow'
          }
        >
          <Card.Header
            className={
              props.pdf ? 'border-bottom-0 pdf-card' : 'border-bottom-0'
            }
          >
            <div className="text-header">{props.title}</div>
          </Card.Header>
          <Card.Body>
            <div className="font-weight-bold text-uppercase">LEASE DETAILS</div>
            <CardRowItem
              title="Total finance amount"
              value={props.data.financeAmount}
              isCurrency="true"
              hideIfNoValue="true"
            />
            <CardRowItem
              title="Vehicle Lease Repayments (per pay) (ex GST)"
              value={props.data.carRepaymentPerPayExGST}
              isCurrency="true"
              hideIfNoValue="true"
            />
            <CardRowItem
              title="Residual Value (Inc GST)"
              value={props.data.leaseResidualAmountIncGST}
              isCurrency="true"
              hideIfNoValue="true"
            />
            <CardRowItem
              title="Residual Percentage"
              value={`${props.data.residualPCT}%`}
              hideIfNoValue="true"
            />
            {props.data.employerDisplayInterestRateOnDigitalEstimate && (
              <CardRowItem
                title="Comparison Interest Rate"
                value={`${props.data.annualRate}%`}
                hideIfNoValue="true"
              />
            )}
            <CardRowItem
              title="Total lease and running costs (per pay) (ex GST)"
              value={props.data.totalLeaseRunningCostsPerPayExGST}
              isCurrency="true"
              hideIfNoValue="true"
            />
            <CardRowItem
              title="Novated Lease Admin Fee (per pay) (ex GST)"
              value={props.data.nlFeePerPayExGST}
              isCurrency="true"
              hideIfNoValue="true"
            />
            <CardRowItem
              title="Vehicle Value for FBT"
              value={props.data.vehicleFBTValue}
              isCurrency="true"
              hideIfNoValue="true"
            />

            <Separator className="mt-3" theme={props.theme} />

            <ProposalSummarySectionCommissions {...props.commissionProps} />

            <Row className="mt-3">
              <Col>
                <p className="subtitle">
                  Oly may also receive commissions and/or rebates in
                  relation to some of the services provided to you through the
                  life of your lease such as Roadside Assist, fleet fuel cards,
                  tyres and windscreens provided by Oly preferred suppliers.
                </p>
              </Col>
            </Row>
            <Row>
              <Col>
                <p className="subtitle">
                  In exchange for the administration of national fleet pricing
                  and quoting services Oly provides to its preferred dealer
                  network Oly may receive a commission.
                </p>
              </Col>
            </Row>
            <Row>
              <Col>
                <p className="subtitle">
                  The costs of Oly's optional aftercare products includes
                  installation costs, warranty charges and may include profit to
                  Oly.
                </p>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Container>
    </div>
  )
}

export default proposalSummarySection
